import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: '1rem',
    float: 'right'
  },

  button: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
